import api from '../services/api';

export interface IWhatsappUsage {
  date: string;
  count: number;
  type: string;
}

export interface IWhatsappReport {
  items: IWhatsappUsage[];
  total_sent: number;
  month: number;
  year: number;
}

export const getWhatsappUsage = async (
  month: number,
  year: number,
): Promise<IWhatsappReport> => {
  const response = await api.get('/whatsapp/billing/usage', {
    params: {
      month,
      year,
    },
  });
  return response.data.data || response.data;
};

export const getWhatsappConnections = async () => {
  const response = await api.get('/whatsapp/connections');
  return response.data;
};

export const createWhatsappConnection = async (payload: any) => {
  const response = await api.post('/whatsapp/connections', payload);
  return response.data;
};

export const updateWhatsappConnection = async (id: string, payload: any) => {
  const response = await api.patch(`/whatsapp/connections/${id}`, payload);
  return response.data;
};

export const deleteWhatsappConnection = async (id: string) => {
  const response = await api.delete(`/whatsapp/connections/${id}`);
  return response.data;
};
